document.addEventListener("DOMContentLoaded", function () {
  var calendarEl = document.getElementById("calendar");

  if (calendarEl && typeof FullCalendar !== "undefined") {
    // Inicializar calendario
    var calendar = new FullCalendar.Calendar(calendarEl, {
      initialView: "timeGridWeek",
      headerToolbar: {
        left: "",
        center: "title",
        right: "timeGridWeek,dayGridWeek",
      },
      // Textos personalizados en español
      buttonText: {
        timeGridWeek: "Vista Semanal",
        dayGridWeek: "Vista Simple",
        today: "Hoy"
      },
      validRange: {
        start: function () {
          var now = new Date();
          var startOfWeek = new Date(now);
          var day = now.getDay();
          var diff = now.getDate() - day + (day == 0 ? -6 : 1); // Lunes como primer día
          startOfWeek.setDate(diff);
          return startOfWeek;
        },
        end: function () {
          var now = new Date();
          var endOfWeek = new Date(now);
          var day = now.getDay();
          var diff = now.getDate() - day + (day == 0 ? -6 : 1) + 6; // Domingo como último día
          endOfWeek.setDate(diff);
          return endOfWeek;
        },
      },
      slotMinTime: "06:00:00",
      slotMaxTime: "24:00:00",
      allDaySlot: false,
      events: function (info, successCallback, failureCallback) {
        // Cargar eventos dinámicamente desde WordPress
        loadProgrammingData(successCallback, failureCallback);
      },
      locale: "es",
      firstDay: 1, // Lunes como primer día de la semana
      weekNumbers: false,
      // Formato de 12 horas
      eventTimeFormat: {
        hour: "numeric",
        minute: "2-digit",
        meridiem: "short",
      },
      slotLabelFormat: {
        hour: "numeric",
        minute: "2-digit",
        meridiem: "short",
      },
      // Evento click para abrir modal
      eventClick: function (info) {
        showProgramModal(info.event);
        info.jsEvent.preventDefault(); // Prevenir comportamiento por defecto
      },
    });

    calendar.render();

    // Inicializar modal
    initModal();
  } else {
    console.error("FullCalendar not loaded or calendar element not found");
  }
});

// Función para cargar datos de programación desde WordPress
function loadProgrammingData(successCallback, failureCallback) {
  // Obtener nonce y URL de AJAX desde las variables globales de WordPress
  var ajaxUrl = tdea_ajax.ajax_url;
  var nonce = tdea_ajax.nonce;

  fetch(ajaxUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      action: "get_radio_programming",
      nonce: nonce,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success && data.data.programacion) {
        if (data.data.debug_info) {
          Object.keys(data.data.debug_info).forEach((dia) => {
            const info = data.data.debug_info[dia];
          });
        }

        var events = transformProgrammingToEvents(data.data.programacion);
        successCallback(events);
      } else {
        console.error("Error en la respuesta:", data);
        failureCallback("Error al cargar la programación");
      }
    })
    .catch((error) => {
      console.error("Error en la petición AJAX:", error);
      failureCallback(error);
    });
}

// Función para transformar datos de programación a eventos de FullCalendar
function transformProgrammingToEvents(programacion) {
  var events = [];
  var diasSemana = {
    lunes: 1,
    martes: 2,
    miercoles: 3,
    jueves: 4,
    viernes: 5,
    sabado: 6,
    domingo: 0,
  };

  // Obtener fecha de inicio de la semana actual
  var now = new Date();
  var startOfWeek = new Date(now);
  var day = now.getDay();
  var diff = now.getDate() - day + (day == 0 ? -6 : 1); // Lunes como primer día
  startOfWeek.setDate(diff);

  Object.keys(programacion).forEach(function (dia) {
    var programasDelDia = programacion[dia];
    var diaNumero = diasSemana[dia.toLowerCase()];

    if (diaNumero === undefined) return;

    // Calcular fecha específica del día
    var fechaDia = new Date(startOfWeek);
    var diasAgregar = diaNumero === 0 ? 6 : diaNumero - 1; // Domingo = 6 días después del lunes
    fechaDia.setDate(startOfWeek.getDate() + diasAgregar);
    var fechaStr = fechaDia.toISOString().split("T")[0]; // YYYY-MM-DD

    programasDelDia.forEach(function (programa) {
      if (!programa.hora_inicio || !programa.hora_fin) return;

      // Convertir horarios a formato ISO
      var startTime = convertTimeToISO(programa.hora_inicio, fechaStr);
      var endTime = convertTimeToISO(programa.hora_fin, fechaStr);

      if (!startTime || !endTime) return;

      // Crear título con programa y presentador
      var title = programa.titulo;
      if (programa.presentador) {
        title += "\n👤 " + programa.presentador;
      }

      // Determinar clase CSS basada en el tag o título
      var className = getEventClassName(programa.titulo, programa.tag);

      events.push({
        title: title,
        start: startTime,
        end: endTime,
        className: className,
        extendedProps: {
          programaId: programa.id,
          presentador: programa.presentador,
          duracion: programa.duracion,
          tag: programa.tag,
          imagen: programa.imagen_url,
        },
      });
    });
  });

  return events;
}

// Función para convertir hora a formato ISO
function convertTimeToISO(timeStr, dateStr) {
  try {
    // Intentar formato 12h primero (ej: "9:00 AM")
    var time12h = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (time12h) {
      var hours = parseInt(time12h[1]);
      var minutes = parseInt(time12h[2]);
      var ampm = time12h[3].toUpperCase();

      if (ampm === "PM" && hours !== 12) hours += 12;
      if (ampm === "AM" && hours === 12) hours = 0;

      var hoursStr = hours.toString().padStart(2, "0");
      var minutesStr = minutes.toString().padStart(2, "0");

      return dateStr + "T" + hoursStr + ":" + minutesStr + ":00";
    }

    // Intentar formato 24h (ej: "09:00")
    var time24h = timeStr.match(/(\d{1,2}):(\d{2})/);
    if (time24h) {
      var hours = parseInt(time24h[1]).toString().padStart(2, "0");
      var minutes = parseInt(time24h[2]).toString().padStart(2, "0");
      return dateStr + "T" + hours + ":" + minutes + ":00";
    }

    return null;
  } catch (error) {
    console.error("Error convirtiendo tiempo:", timeStr, error);
    return null;
  }
}

// Función para determinar la clase CSS del evento
function getEventClassName(titulo, tag) {
  var tituloLower = titulo.toLowerCase();
  var tagLower = tag ? tag.toLowerCase() : "";

  // Programas específicos de TdeA
  if (
    tituloLower.includes("tdea al día") ||
    tituloLower.includes("tdea al dia")
  ) {
    return "programa-tdea-al-dia";
  }

  // Categorías por palabras clave en título
  if (
    tituloLower.includes("emprendimiento") ||
    tagLower.includes("emprendimiento")
  ) {
    return "programa-emprendimiento";
  }

  if (tituloLower.includes("cultura") || tagLower.includes("cultura")) {
    return "programa-cultura";
  }

  if (
    tituloLower.includes("música") ||
    tituloLower.includes("musica") ||
    tituloLower.includes("musical") ||
    tagLower.includes("música") ||
    tagLower.includes("musica")
  ) {
    return "programa-musica";
  }

  if (
    tituloLower.includes("deporte") ||
    tituloLower.includes("deportivo") ||
    tituloLower.includes("fútbol") ||
    tituloLower.includes("futbol") ||
    tagLower.includes("deporte")
  ) {
    return "programa-deportes";
  }

  if (
    tituloLower.includes("noticia") ||
    tituloLower.includes("informativo") ||
    tituloLower.includes("actualidad") ||
    tagLower.includes("noticias")
  ) {
    return "programa-noticias";
  }

  if (
    tituloLower.includes("educativo") ||
    tituloLower.includes("educación") ||
    tituloLower.includes("educacion") ||
    tituloLower.includes("académico") ||
    tituloLower.includes("academico") ||
    tagLower.includes("educativo")
  ) {
    return "programa-educativo";
  }

  if (
    tituloLower.includes("entretenimiento") ||
    tituloLower.includes("entretener") ||
    tituloLower.includes("diversión") ||
    tituloLower.includes("diversion") ||
    tituloLower.includes("show") ||
    tagLower.includes("entretenimiento")
  ) {
    return "programa-entretenimiento";
  }

  if (
    tituloLower.includes("debate") ||
    tituloLower.includes("discusión") ||
    tituloLower.includes("discusion") ||
    tituloLower.includes("mesa redonda") ||
    tagLower.includes("debate")
  ) {
    return "programa-debate";
  }

  if (
    tituloLower.includes("tecnología") ||
    tituloLower.includes("tecnologia") ||
    tituloLower.includes("digital") ||
    tituloLower.includes("tech") ||
    tagLower.includes("tecnologia")
  ) {
    return "programa-tecnologia";
  }

  // Sistema de rotación para programas sin categoría específica
  var defaultColors = [
    "programa-default-1",
    "programa-default-2", 
    "programa-default-3",
    "programa-default-4"
  ];
  
  // Usar el hash del título para generar un índice consistente
  var hash = 0;
  for (var i = 0; i < titulo.length; i++) {
    var char = titulo.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  var index = Math.abs(hash) % defaultColors.length;
  return defaultColors[index];
}

// Funciones del modal
function initModal() {
  var modal = document.getElementById("program-modal");
  var closeBtn = modal.querySelector(".program-modal__close");
  var overlay = modal.querySelector(".program-modal__overlay");

  // Cerrar modal al hacer clic en el botón de cerrar
  closeBtn.addEventListener("click", function () {
    hideModal();
  });

  // Cerrar modal al hacer clic en el overlay
  overlay.addEventListener("click", function () {
    hideModal();
  });

  // Cerrar modal con tecla ESC
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      hideModal();
    }
  });
}

function showProgramModal(event) {
  var modal = document.getElementById("program-modal");
  var extendedProps = event.extendedProps;

  // Llenar información del modal
  document.getElementById("modal-program-title").textContent =
    event.title.split("\n")[0] || "Sin título";

  // Mostrar presentador si existe
  var presenterEl = document.getElementById("modal-program-presenter");
  if (extendedProps.presentador) {
    presenterEl.textContent = extendedProps.presentador;
    presenterEl.style.display = "block";
  } else {
    presenterEl.style.display = "none";
  }

  // Mostrar imagen si existe
  var imageEl = document.getElementById("modal-program-image");
  var imageContainer = imageEl.parentElement;
  if (extendedProps.imagen) {
    imageEl.src = extendedProps.imagen;
    imageEl.alt = event.title.split("\n")[0] || "Imagen del programa";
    imageContainer.style.display = "block";
  } else {
    imageContainer.style.display = "none";
  }

  // Mostrar horario
  var startTime = new Date(event.start);
  var endTime = new Date(event.end);
  var timeStr = formatTime12h(startTime) + " - " + formatTime12h(endTime);
  document.getElementById("modal-program-time").textContent = timeStr;

  // Mostrar duración si existe
  var durationEl = document.getElementById("modal-program-duration");
  if (extendedProps.duracion) {
    durationEl.textContent = extendedProps.duracion;
    durationEl.style.display = "inline-flex";
  } else {
    durationEl.style.display = "none";
  }

  // Mostrar tag si existe
  var tagEl = document.getElementById("modal-program-tag");
  if (extendedProps.tag) {
    tagEl.textContent = extendedProps.tag;
    tagEl.style.display = "inline-flex";
  } else {
    tagEl.style.display = "none";
  }

  // Mostrar descripción si existe
  var descriptionEl = document.getElementById("modal-program-description");
  if (extendedProps.introduccion_corta) {
    descriptionEl.innerHTML = "<p>" + extendedProps.introduccion_corta + "</p>";
    descriptionEl.style.display = "block";
  } else {
    descriptionEl.innerHTML =
      "<p>No hay descripción disponible para este programa.</p>";
  }

  // Mostrar audio si existe
  var audioContainer = document.getElementById("modal-program-audio");
  var audioSource = document.getElementById("modal-audio-source");
  if (extendedProps.audio) {
    audioSource.src = extendedProps.audio;
    audioContainer.style.display = "block";
  } else {
    audioContainer.style.display = "none";
  }

  // Mostrar modal
  modal.classList.add("active");
  document.body.style.overflow = "hidden"; // Prevenir scroll del body
}

function hideModal() {
  var modal = document.getElementById("program-modal");
  modal.classList.remove("active");
  document.body.style.overflow = ""; // Restaurar scroll del body
}

// Función auxiliar para formatear hora en formato 12h
function formatTime12h(date) {
  return date.toLocaleTimeString("es-ES", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}
